
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  mounted: function () {
    const d = myApp.bookingData;
    d.dt = d.datetime.toLocaleString();
    this.$setState({
      name: d.client_code,
      booking: d,
      price: d.settings.booking_price * 1 > 0 ? d.settings.booking_price_type === 'for_person' ? (d.settings.booking_price * 1 * (d.diners * 1)).toFixed(2) : d.settings.booking_price * 1 : 'FREE',
      paypal: d.settings.booking_price * 1 > 0,
      bitcoins: d.settings.booking_price * 1 > 0 && d.promo.bitcoins
    });
    this.getPOI();
  },
  data: function () {
    return {
      lng: lng,
      title: '',
      paypal: false,
      bitdoins: false,
      price: '',
      images: [],
      booking: {
        name: '',
        diners: 0,
        notes: '',
        promo: {},
        settings: {}
      },
      poi: {}
    };
  },
  methods: {
    payWithPaypal() {
      this.confermaPrenotazione('paypal');
    },

    payWithBitcoins() {
      this.confermaPrenotazione('bitcoins');
    },

    getPOI() {
      const self = this,
            app = this.$app,
            $ = this.$;
      myApp.server.get('imc/item/' + myApp.bookingData.poi).then(succ => {
        self.$setState({
          poi: succ
        }, () => {
          app.swiper.destroy('.booking-conform-swiper');
          app.swiper.create({
            el: '.booking-conform-swiper'
          });
        });
      }).catch(err => {
        console.log('getPoi:Error ' + JSON.stringify(err));
      });
    },

    confermaPrenotazione(type) {
      const app = this.$app,
            $ = this.$,
            self = this;
      $('.btn-booking').addClass('hidden');
      $('.btn-booking-preloader').removeClass('hidden');

      const _free = function () {
        myApp.server.post('imc/booking', myApp.bookingData).then(succ => {
          $('.btn-booking').removeClass('hidden');
          $('.btn-booking-preloader').addClass('hidden');
          const popup = app.popup.create({
            el: '.popup-confirm',
            swipeToClose: true
          }).on('close', () => {
            self.$router.navigate('/');
          }).open();
        }).catch(err => {
          console.log(err);
          $('.btn-booking').removeClass('hidden');
          $('.btn-booking-preloader').addClass('hidden');
          app.toast.show({
            text: lng.errorTryLater,
            closeTimeout: 3000,
            cssClass: 'bg-color-red',
            position: 'bottom'
          });
        });
      };

      const _paypal = function () {
        $('.btn-booking').removeClass('hidden');
        $('.btn-booking-preloader').addClass('hidden');
        /*
         myApp.server.post('paypal/uniqueid', myApp.bookingData)
         .then(uniqueid => {
         myApp.bookingData.paypal_ref_id = uniqueid;
         const poi__ = {
         caption: self.poi.caption,
         address: self.poi.address,
         info: self.poi.info,
         legal: self.poi.legal,
         };
         const url = 'https://infomycity.com/pay/?d=' + encodeURIComponent(btoa(JSON.stringify({
         booking: myApp.bookingData,
         poi: poi__,
         })));
         if (window.cordova && cordova.InAppBrowser) {
         const callback = function (ev) {
         // https://infomycity.com/#infoMyCityOrderStatusCompleted_27250270EF526692D
         if (ev.type == 'loadstart' && ev.url.match('infoMyCityOrderStatusCompleted')) {
         const paypal_capture_id = ev.url.substr(55);
         myApp.bookingData.promo.paypal_capture_id = paypal_capture_id;
         myApp.bookingData.promo.paypal_ref_id = uniqueid;
         inAppBrowserRef.close();
         _free();
         } else if (ev.type == 'loadstart' && ev.url.match('infoMyCityOrderStatusAborted')) {
         console.log('aborted');
         inAppBrowserRef.close();
         }
         };
         const opt = 'location=no,toolbar=no' +
         ',hardwareback=no,hidenavigationbuttons=yes,zoom=no';
         const inAppBrowserRef = cordova.InAppBrowser.open(url, '_blank', opt);
         inAppBrowserRef.addEventListener('loadstart', callback);
         inAppBrowserRef.addEventListener('loadstop', callback);
         inAppBrowserRef.addEventListener('loaderror', callback);
         inAppBrowserRef.addEventListener('beforeload', callback);
         inAppBrowserRef.addEventListener('message', callback);
         inAppBrowserRef.addEventListener('exit', callback);
         } else {
         // solo per test
         window.open(url);
         // produzione
         //app.dialog.alert('Disabilitato nel web');
         }
         }).catch(err => {
         console.log(err);
         app.toast.show({text: lng.errorTryLater, closeTimeout: 3000, cssClass: 'bg-color-red', position: 'bottom'});
         });
         
         */

        const order = {
          order: myApp.bookingData,
          me: myApp.user
        }; // imposta preorder con tutti i dati

        myApp.server.post('imc/preorder', order).then(succ => {
          const url = 'https://infomycity.com/booking/' + succ + '/' + (app.device.ios ? 'ios' : 'android');

          if (window.cordova && cordova.InAppBrowser) {
            const callback = function (ev) {
              if (ev.type == 'loadstart' && ev.url.match('infoMyCityOrderStatusCompleted')) {
                const paypal_capture_id = ev.url.substr(55);
                inAppBrowserRef.close();
                order.preorder_id = succ;
                order.paypal_capture_id = paypal_capture_id;
                app.dialog.alert('Il tuo ordine è stato inviato', () => {
                  app.popup.close();
                  myApp.order = null;
                  self.order = null;
                  self.order_price = 0;
                  self.delivery_price = 0;
                  self.total_price = 0;
                  self.$router.back();
                });
              } else if (ev.type == 'loadstart' && ev.url.match('infoMyCityOrderStatusAborted')) {
                console.log('aborted');
                inAppBrowserRef.close();
              }
            };

            const opt = 'location=no,toolbar=no' + ',hardwareback=no,hidenavigationbuttons=yes,zoom=no';
            const target = app.device.ios ? '_blank' : '_self';
            const inAppBrowserRef = cordova.InAppBrowser.open(url, target, opt);
            inAppBrowserRef.addEventListener('loadstart', callback);
            inAppBrowserRef.addEventListener('loadstop', callback);
            inAppBrowserRef.addEventListener('loaderror', callback);
            inAppBrowserRef.addEventListener('beforeload', callback);
            inAppBrowserRef.addEventListener('message', callback);
            inAppBrowserRef.addEventListener('exit', callback);
          } else {
            // solo per test
            window.open(url); // produzione
            //app.dialog.alert('Disabilitato nel web');
          }
        }).catch(err => {
          console.log(err);
          app.toast.show({
            text: lng.genericError,
            closeTimeout: 3000,
            cssClass: 'bg-color-red',
            position: 'bottom'
          });
        }).finally(() => {
          console.log('finally');
        });
      };

      const _bitcoins = function () {
        $('.btn-booking').removeClass('hidden');
        $('.btn-booking-preloader').addClass('hidden');

        if (window.cordova) {
          const ref = cordova.InAppBrowser.open('https://rest.dreamgest.com/infomycity/payment.php', '_blank', 'location=no');
        } else {
          const ref = window.open('https://rest.dreamgest.com/infomycity/payment.php', '_blank', 'location=no');
        }
      };

      switch (type) {
        case 'free':
          _free();

          break;

        case 'bitcoins':
          _bitcoins();

          break;

        case 'paypal':
          _paypal();

          break;
      }
    }

  },
  id: '509fcebfa5',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="title">';
      r += c(ctx_1.lng.confirmBooking, ctx_1);
      r += '</div>\n      </div>\n    </div>\n    <div class="page-content bg-color-white">\n\n      <div class="swiper-container booking-conform-swiper">\n        <div class="swiper-wrapper">\n          ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.poi.images, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class="swiper-slide"><div class="slide-bg h-33" style="background-image: url(';
          r += c(ctx_2.url, ctx_2);
          r += ')"></div></div>\n          ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class="swiper-slide"><div class="slide-bg h-33" style="background-image: url(';
          r += c(ctx_1.type, ctx_2);
          r += ')"></div></div>\n          ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n        <div class="slide-bg-title">';
      r += c(ctx_1.poi.caption, ctx_1);
      r += '</div>\n      </div>\n\n      <div class="block" style="margin-top: 20px">\n        <div class="booking-confirm-item">\n          <img width="32" src="static/Cliente.png" alt=""/>\n          <span class="title">';
      r += c(ctx_1.lng.client, ctx_1);
      r += '</span>\n          ';
      r += c(ctx_1.booking.client_code, ctx_1);
      r += '\n        </div>\n        <div class="booking-confirm-item">\n          <img width="32" src="static/DataOra.png" alt=""/>\n          <span class="title">';
      r += c(ctx_1.lng.dateAndTime, ctx_1);
      r += ':</span>\n          ';
      r += c(ctx_1.booking.dt, ctx_1);
      r += '\n        </div>\n        <div class="booking-confirm-item">\n          <img width="32" src="static/Coperti.png" alt=""/>\n          <span class="title">';
      r += c(ctx_1.lng.diners, ctx_1);
      r += ':</span>\n          ';
      r += c(ctx_1.booking.diners, ctx_1);
      r += '\n        </div>\n        <div class="booking-confirm-item">\n          <div class="col-auto">\n            <img width="32" src="static/Note.png" alt=""/>\n          </div>\n          <div class="col-auto pl-1">\n            <span class="title">';
      r += c(ctx_1.lng.notes, ctx_1);
      r += ':</span>\n          </div>\n          <div class="col-auto pl-1">\n            ';
      r += c(ctx_1.booking.notes, ctx_1);
      r += '\n          </div>\n        </div>\n        <div class="booking-confirm-item">\n          <i class="f7-icons icon-rounded bg-color-deeppurple text-color-white">star_fill</i>\n          <span class="title">';
      r += c(ctx_1.lng.promoCode, ctx_1);
      r += ':</span>\n          ';
      r += c(ctx_1.booking.promo.promo_code, ctx_1);
      r += '\n        </div>\n        <div class="booking-confirm-item">\n          <img width="32" src="static/Costo.png" alt=""/>\n          <span class="title">';
      r += c(ctx_1.lng.bookingPrice, ctx_1);
      r += ':</span>\n          ';
      r += c(ctx_1.poi.currency, ctx_1);
      r += ' ';
      r += c(ctx_1.price, ctx_1);
      r += '\n        </div>\n        <div class="text-align-center btn-booking">\n          \n          ';
      r += Template7Helpers.js_if.call(ctx_1, "this.paypal && this.booking.settings.paypal_enabled", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <button @click="payWithPaypal" style="margin-top: 25px; margin-bottom: 8px" class="button button-fill button-large button-round">\n            ';
          r += c(ctx_2.lng.buyNowWith, ctx_2);
          r += ' \n            <img height="24" src="static/paypal-icon.svg" style="vertical-align: middle">\n            <img height="24" src="static/paypal.svg" style="vertical-align: middle">\n          </button>\n          <div class="text-align-center">\n            <img style="max-width: 90%"  @click="payWithPaypal"\n                 src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/cc-badges-ppmcvdam.png" \n                 alt="Buy now with PayPal" />\n          </div>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          \n          <!--\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.bitcoins, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <a href="#"  @click="payWithBitcoins" \n             class="button button-large button-round button-fill bg-color-imc text-color-primary" style="width:73vw; margin: 0 auto">\n            <i class="icon f7-icons">bitcoin</i>\n          </a>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          -->\n\n\n          ';
      r += Template7Helpers.js_if.call(ctx_1, "!this.paypal || this.booking.settings.booking_cash", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class="padding" style="margin-top: 40px">\n\n            ';
          r += Template7Helpers.js_if.call(ctx_2, "this.paypal && this.booking.settings.paypal_enabled && this.booking.settings.booking_cash", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n            <h4>';
              r += c(ctx_3.lng.orPaymentCash, ctx_3);
              r += '</h4>\n            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n            <a href="#" @click="confermaPrenotazione(\'free\')" class="button button-large button-fill button-round bg-imc text-color-white">\n              ';
          r += c(ctx_2.lng.confirmBooking, ctx_2);
          r += '\n              <img width="22" src="static/check.png" alt=""/></a>\n          </div>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n        </div>\n        <div class="padding text-align-center btn-booking-preloader hidden" style="margin-top: 40px">\n          <a href="#" class="button button-large button-fill button-round bg-imc text-color-white">\n            <div class="preloader"></div> &nbsp;&nbsp;&nbsp;\n            <img width="22" src="static/check.png" alt=""/></a>\n        </div>\n      </div>\n    </div>\n\n    <div class="popup popup-confirm">\n      <div class="view">\n        <div class="page">\n          <div class="navbar bg-color-imc">\n            <div class="navbar-bg bg-color-imc"></div>\n            <div class="navbar-inner bg-color-imc">\n              <div class="title center sliding">';
      r += c(ctx_1.lng.bookingOkTitle, ctx_1);
      r += '</div>\n              <div class="right">\n                <a class="link popup-close">\n                  <i class="icon f7-icons text-color-primary">multiply_circle_fill</i>\n                </a>\n              </div>\n            </div>\n          </div>\n          <div class="page-content">\n            <div class="block text-align-left">\n              <p>\n                ';
      r += c(ctx_1.lng.bookingOkMessage1, ctx_1);
      r += '\n              </p>\n              <p>\n                ';
      r += c(ctx_1.lng.bookingOkMessage2, ctx_1);
      r += '\n              </p>\n              <p>\n                ';
      r += c(ctx_1.lng.bookingOkMessage3, ctx_1);
      r += '\n              </p>\n              <p>\n                ';
      r += c(ctx_1.lng.bookingOkMessage4, ctx_1);
      r += '\n              </p>\n              <div class=\'row  text-align-center\'>\n                <div class=\'col\'>\n                  <img class=\'responsive\' src="static/menu.png" alt=""/>\n                </div>\n                <div class=\'col\'>\n                  <img class=\'responsive\' src="static/menu1.png" alt=""/>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    